import styled from 'styled-components';

export const SettingsFormContainer = styled.div`

`